/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StorefrontSection {
  FAQS = 'FAQS',
  REVIEWS = 'REVIEWS',
  ABOUT = 'ABOUT',
  ORDER_PAGES = 'ORDER_PAGES',
  CUSTOM_INQUIRY = 'CUSTOM_INQUIRY',
  PASS_ORDER_PAGES = 'PASS_ORDER_PAGES',
  TRIALS = 'TRIALS',
  GIFT_CARD = 'GIFT_CARD',
}
